import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const UpdateTcSlice = createSlice({
  name: "updateTc",
  initialState,
  reducers: {
    updateTcRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateTcRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
      state.error = null;
    },
    updateTcRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateTcRequest,
  updateTcRequestSuccess,
  updateTcRequestError,
} = UpdateTcSlice.actions;

export default UpdateTcSlice.reducer;
